import { FC, ReactNode } from 'react'

import { Footer } from './footer'
import { Header } from './header'

export type LayoutProps = {
  children?: ReactNode
}

export const Layout: FC<LayoutProps> = ({ children }) => (
  <>
    <Header onTop={false} isTransparent={false} inverted={false} />
    {children}
    <Footer />
  </>
)
